import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

const humanDateReader = (date: string | Date | dayjs.Dayjs): string => {
  dayjs.extend(relativeTime);

  const value = dayjs().to(dayjs(date));
  return value;
};

export default humanDateReader;
